import { TranslationService } from '../../api';
import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';

export const fetchTranslations =
  () => async (dispatch: Dispatch<ReduxAction>) => {
    new TranslationService().getTranslations().then(response => {
      dispatch({
        type: ActionTypes.FETCH_TRANSLATIONS,
        payload: response.data,
      });
    });
  };
